import type AhaEditor from '../../AhaEditor';

const TableSelectionUpdatePlugin = {
  name: 'Table onSelectionUpdate handler',
  handlers: {
    onSelectionUpdate: (ahaEditor: AhaEditor) => {
      const { editor, controller } = ahaEditor;
      const { tableSelection } = controller.state.pluginState;
      if (!tableSelection) return;

      if (tableSelection.shouldClearSelection) {
        tableSelection.reset();
        tableSelection.shouldClearSelection = false;
      }

      if (tableSelection.isUpdatingSelection) {
        tableSelection.isUpdatingSelection = false;
        return;
      }

      tableSelection.refreshTableSelection(editor);
    },
  },
};

export default TableSelectionUpdatePlugin;
